import { ConfigProvider, Empty, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export default function NoDataFound() {
  return (
    <Empty
      image="https://i.pinimg.com/236x/56/46/be/5646be2b200df93b547784b2903c3a2e.jpg"
      imageStyle={{ mixBlendMode: "color-burn", width: "100%", height: "100%", objectFit: "cover"}}
      description={
        <div>
          <h5>No Data Found</h5>
          <p>We are finding list of data please wait...</p>
          {/* <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#800000",
              },
            }}
          >
            <Spin indicator={<LoadingOutlined spin />} spinning></Spin>
          </ConfigProvider> */}
        </div>
      }
    />
  );
}
